var _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommentClick(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1449 1.61719H3.83162C2.12599 1.61719 0.738281 3.00462 0.738281 4.71053V14.6939C0.738281 16.396 2.11995 17.7812 3.82063 17.7873V22.3176L10.3313 17.7873H20.1449C21.8506 17.7873 23.2383 16.3996 23.2383 14.6939V4.71053C23.2383 3.00462 21.8506 1.61719 20.1449 1.61719ZM21.9199 14.6939C21.9199 15.6725 21.1237 16.4689 20.1449 16.4689H9.91763L5.13899 19.7942V16.4689H3.83162C2.85287 16.4689 2.05664 15.6725 2.05664 14.6939V4.71053C2.05664 3.73164 2.85287 2.93555 3.83162 2.93555H20.1449C21.1237 2.93555 21.9199 3.73164 21.9199 4.71053V14.6939Z",
    fill: "#303030",
    stroke: "black",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76025 6.27563H17.2162V7.59399H6.76025V6.27563Z",
    fill: "#303030"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76025 9.08813H17.2162V10.4065H6.76025V9.08813Z",
    fill: "#303030"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76025 11.9006H17.2162V13.219H6.76025V11.9006Z",
    fill: "#303030"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentClick);
export default __webpack_public_path__ + "static/media/comment_click.4a3f7c819b0e5edbfea5cb53dfe01b98.svg";
export { ForwardRef as ReactComponent };